export const mutations = {
  SET_ERRORS: (state, errors) => {
    state.errors = errors
  },
  CLEAR_ERRORS: state => {
    state.errors = null
  },
}
